import { combineReducers } from "redux";
import Settings from "./Settings";
import I18n from "./I18n";
import I18nMaster from "./I18nMaster";
import I18nDashboard from "./I18nDashboard";
import I18nCustomer from "./I18nCustomer";
import I18nCustomerFocus from "./I18nCustomerFocus";
import Auth from "./Auth";
import Dashboard from "./Dashboard";
import SaleByProvince from "./SaleByProvince";
import PostFeed from "./PostFeed";
import Customer from "./Customer";
import CustomerFocus from "./CustomerFocus";
import Salesman from "./Salesman";
import SalesmanMaster from "./SalesmanMaster";
import Main from "./Main";
import Product from "./Product";
import Report from "./Report";
import OrderTransaction from "./OrderTransaction";
import SupplierPOTransaction from "./SupplierPOTransaction";
import SupplierPRTransaction from "./SupplierPRTransaction";
import SupplierReturn from "./SupplierReturn";
import InvoiceTransaction from "./InvoiceTransaction";
import ReturnTransaction from "./ReturnTransaction";
import CreditNoteTransaction from "./CreditNoteTransaction";
import ReceiptTransaction from "./ReceiptTransaction";
import ArReport from './ArReport';
import Notification from "./Notification";
import expensereportTransaction from "./expensereportTransaction";
import expenseTransaction from "./expenseTransaction";
import QuotationTransaction from "./QuotationTransaction";
import Supplier from "./Supplier";

export default combineReducers({
  settings: Settings,
  i18n: I18n,
  i18nMaster: I18nMaster,
  i18nDashboard: I18nDashboard,
  i18nCustomer: I18nCustomer,
  i18nCustomerFocus: I18nCustomerFocus,
  auth: Auth,
  dashboard: Dashboard,
  saleByProvince: SaleByProvince,
  postFeed: PostFeed,
  customer: Customer,
  customerFocus: CustomerFocus,
  salesman: Salesman,
  salesmanMaster: SalesmanMaster,
  main: Main,
  product: Product,
  report: Report,
  orderTransaction: OrderTransaction,
  supplierPOTransaction: SupplierPOTransaction,
  quotationTransaction: QuotationTransaction,
  supplierReturn: SupplierReturn,
  invoiceTransaction: InvoiceTransaction,
  returnTransaction: ReturnTransaction,
  creditNoteTransaction: CreditNoteTransaction,
  receiptTransaction: ReceiptTransaction,
  arReport: ArReport,
  notification: Notification,
  expensereportTransaction: expensereportTransaction,
  expenseTransaction: expenseTransaction,
  supplier: Supplier,
    supplierPRTransaction: SupplierPRTransaction,
});
